import { jsxs as y, jsx as a } from "react/jsx-runtime";
import R, { useRef as w, useState as L, useEffect as _ } from "react";
import { R as g } from "../chunks/index.b09c00db.js";
import { _ as z, f as I } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { styled as p, css as f } from "styled-components";
const c = p.span.withConfig({
  displayName: "Label",
  componentId: "sc-18mxx9x-0"
})(["color:var(--text-label-color);"]), $ = p.div.withConfig({
  displayName: "Counter",
  componentId: "sc-18mxx9x-1"
})(["min-width:198px;align-items:center;justify-content:space-between;display:inline-flex;", " ", ""], (n) => n.size === "sm" && f`
      ${c} {
        ${z}
        padding: var(--spacing-none) var(--spacing-1x);
      }
    `, (n) => n.size === "lg" && f`
      ${c} {
        ${I}
        padding: var(--spacing-none) var(--spacing-2x);
      }
    `), j = R.forwardRef(({
  size: n = "sm",
  value: o = 0,
  inputProps: e,
  buttonLeftProps: x,
  buttonRightProps: b,
  ...C
}, h) => {
  const i = w(), [t, s] = L(o);
  _(() => {
    s(o);
  }, [o]);
  const r = (v) => {
    var u;
    const d = v === "inc" ? t + 1 : t - 1;
    if (s(d), e != null && e.onChange) {
      const m = new Event("input", {
        bubbles: !0
      });
      i.current.value = d.toString(), (u = i.current) == null || u.dispatchEvent(m), e.onChange(m);
    }
  }, l = n;
  return /* @__PURE__ */ y($, { size: n, ref: h, "data-testid": "rango-counter", "data-rango-component": "rango-counter", "data-is-rango": !0, ...C, children: [
    /* @__PURE__ */ a(g, { ...x, size: l, icon: "MinusLine", disabled: t <= 0, onClick: () => r("dec") }),
    /* @__PURE__ */ a(c, { children: t }),
    /* @__PURE__ */ a("input", { readOnly: !0, type: "hidden", value: t, ...e, ref: i }),
    /* @__PURE__ */ a(g, { ...b, size: l, icon: "PlusLine", onClick: () => r("inc") })
  ] });
});
j.displayName = "RangoCounter";
export {
  j as RangoCounter
};
